import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { Card } from '@hivebrite/design-system/Card';

import FolderThumbnailContent from './components/FolderThumbnailContent';
import ThumbnailBottom from '../components/ThumbnailBottom';
import ThumbnailContent from '../components/ThumbnailContent';
import ThumbnailHeader from '../components/ThumbnailHeader';

export const Wrapper = ({ header, children }) => (
  <Card flexDirection="column" width="100%" p={0} my={4} position="relative">
    <ThumbnailHeader isFolder {...header} />
    {children}
  </Card>
);

const Content = ({ tag, content, bottom }) => (
  <>
    <ThumbnailContent tag={tag}>
      <FolderThumbnailContent {...content} />
    </ThumbnailContent>
    {bottom && <ThumbnailBottom {...bottom} />}
  </>
);

const FolderThumbnail = ({ bottom, content, link, tag, header }) => (
  <Wrapper header={header}>
    {link ? (
      <LinkWrapperStyled
        data-testid="thumbnail-link"
        to={link.to}
        aria-label={s__(
          'Accessibility|Click to go on the folder page of %{foldername}',
        ).i__({
          foldername: content.name,
        })}
      >
        <Content tag={tag} content={content} bottom={bottom} />
      </LinkWrapperStyled>
    ) : (
      <Content tag={tag} content={content} bottom={bottom} />
    )}
  </Wrapper>
);

FolderThumbnail.propTypes = {
  bottom: PropTypes.object,
  content: PropTypes.object.isRequired,
  header: PropTypes.object.isRequired,
  link: PropTypes.object,
  tag: PropTypes.string.isRequired,
};

export default FolderThumbnail;

const LinkWrapperStyled = styled(Link)`
  div:nth-child(2):hover div {
    color: ${({ theme }) => theme.colors.link};
    text-decoration: underline;
  }
`;
